import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

const clipboardAPI = 'clipboard';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {  

  constructor() { }

  getClipboardAPISupport(): boolean {
    return clipboardAPI in navigator;
  }

  getClipboardAPI(): any {
    return navigator[clipboardAPI];
  }

  copyToClipboard(val: string): Observable<boolean> {
    if (this.getClipboardAPISupport()) {
      const clipboard = this.getClipboardAPI();
      return new Observable<boolean>((observer) => {
        clipboard.writeText(val)
          .then(() => {
            observer.next(true);
            observer.complete();
          })
          .catch((e) => {
            observer.next(false);
            observer.complete();
          });
      });
    } else { // async copy unsupported
      return of(false);
    }
  }

  copyInputFieldValue(input: HTMLInputElement | HTMLTextAreaElement): boolean {
    input.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (err) {
      copied = false;
    }
    return copied;
  }
}
